import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TimePicker } from 'antd';
import './TimePickerTool.scss';

class TimePickerTool extends Component {
  constructor(props) {
    super(props);

    this.attachBindings();
  }

  attachBindings() {
    this.onTimeChange = this.onTimeChange.bind(this);
  }

  onTimeChange = (selectedTime, timeString) => {
    this.props.onTimeChange(selectedTime, timeString, this.props.index);
  }

  render() {
    return (<div>
      {this.props.use12Hours && <TimePicker
      use12Hours
      className={this.props.className? this.props.className : ""}
      popupClassName={this.props.className? this.props.className : ""}
      popupStyle={{width: this.props.popupWidth}}
      style={{width: this.props.width}}
      value={this.props.value}
      onChange={this.onTimeChange}
      placeholder={this.props.placeholder}
      format={this.props.format}
      />}
      {this.props.disabled && <TimePicker
      className={this.props.className? this.props.className : ""}
      popupClassName={this.props.className? this.props.className : ""}
      popupStyle={{width: this.props.popupWidth}}
      style={{width: this.props.width}}
      value={this.props.value}
      onChange={this.onTimeChange}
      placeholder={this.props.placeholder}
      format={this.props.format}
      disabled
      />}
      {this.props.use12Hours==false && this.props.disabled==false && <TimePicker
      className={this.props.className? this.props.className : ""}
      popupClassName={this.props.className? this.props.className : ""}
      popupStyle={{width: this.props.popupWidth}}
      style={{width: this.props.width}}
      value={this.props.value}
      onChange={this.onTimeChange}
      placeholder={this.props.placeholder}
      format={this.props.format}
      />}
    </div>);
  }

}

TimePickerTool.propTypes = {
  placeholder: PropTypes.string,
  format: PropTypes.string,
  disabled: PropTypes.bool,
  use12Hours: PropTypes.bool,
  className: PropTypes.string,
  popupClassName: PropTypes.string,
  popupWidth: PropTypes.string,
  width: PropTypes.string,
  onTimeChange: PropTypes.func.isRequired,
};

TimePickerTool.defaultProps = {
  placeholder: '',
  format: 'HH:mm:ss',
  disabled: false,
  use12Hours: false,
  className: '',
  popupClassName: '',
  popupWidth: '250px',
  width:'250px',
};
export default TimePickerTool;
